import { checkBeforeReturnCar } from '@/api/domain/finance'
import { getOrderMobile } from '@/api/domain/orders'
import { PERSONAL_ADD_PATH } from '@/pages/orders/orderRenewal/list/config'
import { operateMaxShowLength } from '@/store/dict/config'
import { ORDER_STATE } from '@/store/dict/order.js'
import { CATEGORY_CODE_MAP, ONE_KEY_CHANGE_STATUS } from '@/store/dict/rentPlanDict.js'
import selectOptionDict from '@/store/dict/selectOptionDict'

// 签约状态:0待确认/1已开启/2已解约/99未开启
export const walletWithhold2State = {
  TO_BE_CONFIRMED: 0,
  OPENED: 1,
  TERMINATED: 2,
  UNOPENED: 99,
}

export default function () {
  const allTabList = [
    {
      value: '',
      key: 'allOrderNum',
      state: 0,
      name: '全部',
      cacheData: { // 每个tab需要缓存的列表数据（list数据和分页数据）
        isLoaded: false, // 是否已经加载过
        pageNum: 1,
        pageSize: 10,
        total: 0,
        listData: [],
      },
    },
    {
      value: '',
      key: 'toBindOrderNum',
      state: 5,
      name: '待绑车',
      cacheData: {
        isLoaded: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        listData: [],
      },
    },
    {
      value: '',
      key: 'toProcessWithoutToBindCarOrderNum',
      state: 10,
      name: '待履约',
      cacheData: {
        isLoaded: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        listData: [],
      },
    },
    {
      value: '',
      key: 'inProcessOrderNum',
      state: 2,
      name: '履约中',
      cacheData: {
        isLoaded: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        listData: [],
      },
    },
    {
      value: '',
      key: 'inAccountOrderNum',
      state: 3,
      name: '退车核算',
      cacheData: {
        isLoaded: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        listData: [],
      },
    },
    {
      value: '',
      key: 'closedOrderNum',
      state: 4,
      name: '已关闭',
      cacheData: {
        isLoaded: false,
        pageNum: 1,
        pageSize: 10,
        listData: [],
      },
    },
  ]
  const stayProcessTabList = [
    { value: '', key: 'toProcessWithoutToBindCarOrderNum', state: 10, name: '全部' },
    { value: '', key: 'toConfirmOrderNum', state: 11, name: '合同待签署' },
    { value: '', key: 'toPaymentOrderNum', state: 13, name: '订单待支付' },
    { value: '', key: 'confirmedOrderNum', state: 12, name: '发车待验车' },
  ]
  const accountingTabList = [
    { value: '', key: 'inAccountOrderNum', state: 3, name: '全部' },
    { value: '', key: 'toInStockOrderNum', state: 31, name: '退车待验车' },
    { value: '', key: 'toAccountOrderNum', state: 32, name: '订单待核算' },
    {
      value: '',
      key: 'toReceivableOrderNum',
      state: 33,
      name: '费用待结算',
    },
  ]
  const headData = [
    {
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '订单ID',
        fixed: 'left',
        width: '110',
      },
      render: ({ row }) => {
        return this.$createElement(
          'span',
          {
            class: 'orderId',
            style: {
              cursor: 'pointer',
              color: '#276BEC',
            },
            on: {
              click: () => this.toOrderDetailPage({ id: row.id }),
            },
          },
          row.id,
        )
      },
    },
    {
      name: 'plateNo',
      columnProps: {
        prop: 'plateNo',
        label: '车牌号',
        width: 100,
        showEllipsisTooltip: true,
        limitEllipsisLine: 1,
      },
    },
    {
      name: 'city',
      columnProps: {
        prop: 'city',
        label: '运营城市',
      },
    },
    {
      name: 'customerName',
      columnProps: {
        prop: 'customerName',
        label: '司机姓名',
        width: 110,
      },
    },
    {
      name: 'customerSafetyTel',
      columnProps: {
        prop: 'customerSafetyTel',
        label: '下单手机号',
        width: 150,
      },
      render: ({ row }) => {
        if (!row.customerSafetyTel) {
          return '--'
        }
        const isRevealed = row._mobileRevealed
        const isLoading = row._mobileLoading
        const displayTel = isRevealed
          ? (row._revealedMobile || row.customerSafetyTel)
          : row.customerSafetyTel
        const hasPermission = this.judgePermission(
          'workbench_rent_order_show_order_mobile',
        )
        const children = [this.$createElement('span', displayTel)]
        if (hasPermission && !isRevealed) {
          children.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
                size: 'mini',
                loading: isLoading,
              },
              style: {
                marginLeft: '4px',
                padding: '0',
              },
              on: {
                click: async () => {
                  this.$set(row, '_mobileLoading', true)
                  try {
                    const { code, data } = await getOrderMobile({
                      rentOrderId: row.id,
                      customerId: row.customerId,
                    })
                    if (code === 1 && data?.userMobile) {
                      this.$set(row, '_revealedMobile', data.userMobile)
                      this.$set(row, '_mobileRevealed', true)
                    }
                  } finally {
                    this.$set(row, '_mobileLoading', false)
                  }
                },
              },
            }, '查看'),
          )
        }
        return this.$createElement(
          'span',
          {
            style: {
              display: 'inline-flex',
              alignItems: 'center',
            },
          },
          children,
        )
      },
    },
    {
      name: 'planName',
      columnProps: {
        prop: 'planName',
        label: '租赁方案',
        width: 140,
      },
    },
    {
      name: 'gmtCreate',
      columnProps: {
        prop: 'gmtCreate',
        label: '订单创建时间',
        width: '160',
      },
    },
    {
      name: 'rentCategoryName',
      columnProps: {
        prop: 'rentCategoryName',
        label: '租赁类别',
      },
    },
    {
      name: 'rentAmount',
      columnProps: {
        prop: 'rentAmount',
        label: '每期租金',
        width: '220',
      },
    },
    {
      name: 'walletWithholdState',
      columnProps: {
        width: '110',
        label: '网约钱包支付',
      },
      render: ({ row }) => {
        return this.$createElement(
          'div',
          [
            row.dayAndWeekWalletWithhold?.status !== undefined && row.dayAndWeekWalletWithhold?.status !== null
              ? selectOptionDict.walletWithholdState[row.dayAndWeekWalletWithhold?.status]
              : '--',
            // 判断是否有提示文字
            row.dayAndWeekWalletWithhold?.noOpenReason
              ? this.$createElement(
                'el-tooltip',
                {
                  props: {
                    placement: 'top-start',
                    content: row.dayAndWeekWalletWithhold?.noOpenReason,
                  },
                },
                [
                  this.$createElement('i', { class: 'el-icon-question' }),
                ],
              )
              : '',
          ],
        )
      },
    },
    {
      name: 'personalWithholdState',
      columnProps: {
        width: '100',
        label: '支付宝支付',
      },
      render: ({ row }) => {
        const { reason } = row.personalWithholdState
        const parseReason = reason ? JSON.parse(reason) : []

        return this.$createElement(
          'div',
          [
            row.personalWithholdState?.signState !== undefined
              && row.personalWithholdState?.signState !== null
              ? selectOptionDict.alipayWithholdStateNew[row.personalWithholdState?.signState]
              : '- -',
            // 判断是否有提示文字
            reason
              ?
              this.$createElement(
                'el-tooltip',
                {
                  props: {
                    placement: 'top-start',
                    effect: 'dark',
                  },
                },
                [
                  this.$createElement('i', { class: 'el-icon-question' }),
                  this.$createElement('div', {
                    slot: 'content',
                  },
                  [
                    parseReason.map((item) => this.$createElement('p', item)),
                  ]),
                ],
              ) : '',
          ],
        )
      },
    },
    {
      name: 'deposit',
      columnProps: {
        label: '总押金/已收',
        width: '150',
        align: 'left',
      },
      render: ({ row }) => {
        if (row.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
          return '--'
        }
        return `${row.deposit === null ? '0.00' : row.deposit}` +
          '/' +
          `${row.receivedDeposit}`
      },
    },
    {
      name: 'startDate',
      columnProps: {
        label: '合同周期',
        prop: 'startDate',
        width: '110',
      },
      render: ({ row }) => {
        if (row.startDate) {
          return `${row.startDate} ~ ${row.contractEndDate}`
        }
        return '--'
      },
    },
    {
      name: 'contractFilingStateName',
      columnProps: {
        prop: 'contractFilingStateName',
        label: '合同备案状态',
        width: '120',
      },
    },
    {
      name: 'state',
      columnProps: {
        label: '订单状态',
        width: '100',
        formatter: (row) => selectOptionDict.leaseOrderState[row.state],
      },
    },
    {
      name: 'source',
      columnProps: {
        label: '下单方式',
        formatter: (row) => selectOptionDict.source[row.source],
      },
    },
    {
      name: 'createUser',
      columnProps: {
        prop: 'createUser',
        width: '110',
        label: '订单创建人',
      },
    },
    {
      name: 'deptName',
      columnProps: {
        prop: 'deptName',
        label: '所属部门',
        width: 150,
      },
      showEllipsisTooltip: true,
      limitEllipsisLine: 1,
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        width: 240,
        fixed: 'right',
      },
      type: 'operate',
      maxShowLength: operateMaxShowLength,
      getOperateList: ({ row }) => {
        // 待履约
        //   --订单待确认 0
        //   --发车待验车 1500
        // 履约中 2500
        // 退车核算
        //   --退车待验车 3500
        //   --订单待核算 4500
        // 已关闭 state === 5500
        const actionArr = [
          {
            label: '绑车',
            permission: this.judgePermission('for_rent_sign_contract_rent_order_create') && [-1500].includes(Number(row.state)),
            action: () => this.handleToBindCar(row),
          },
          {
            label: '签署合同',
            permission: this.judgePermission('workbench_rent_order_confirm') && row.state === 0,
            action: () => this.toOrderConfirmPage(row),
          },
          {
            label: '订单续约',
            permission: row.showRenewal && this.judgePermission('workbench_rent_order_renewal_of_contract'),
            action: () => {
              this.$router.push({ path: PERSONAL_ADD_PATH, query: { oldOrderId: row.id } })
            },
          },
          {
            label: '财务收款',
            permission: [ORDER_STATE.TO_PAY].includes(Number(row.state)) && this.judgePermission('workbench_rent_order_finance_detail'),
            action: () => this.toReceiptandpayment(row),
          },
          {
            label: '验车出库',
            permission: this.judgePermission('workbench_rent_order_to_out_stock') && Number(row.state) === ORDER_STATE.TO_CHECK_FOR_SEND,
            action: () => this.outInBankPop(row.carId, 1, row.relatedType, row),
          },
          {
            label: '退车解约',
            permission: this.judgePermission('workbench_rent_order_cancel_contract') && [ORDER_STATE.TO_CONFIRM, ORDER_STATE.TO_PAY, ORDER_STATE.TO_CHECK_FOR_SEND, ORDER_STATE.RENTING].includes(Number(row.state)),
            action: async () => {
              const { code } = await checkBeforeReturnCar({
                orderId: row.id,
              })
              if (code === 1) {
                // “待履约”状态退车走原有逻辑，其余跳转到客户还车页面
                if ([ORDER_STATE.TO_CONFIRM, ORDER_STATE.TO_PAY, ORDER_STATE.TO_CHECK_FOR_SEND].includes(Number(row.state))) {
                  this.closeTheCar(row)
                } else {
                  this.toReturnCarPage(row)
                }
              }
            },
          },
          {
            label: '退车验车',
            permission: this.judgePermission('workbench_rent_order_to_in_stock') && Number(row.state) === ORDER_STATE.TO_CHECK_FOR_RETURN,
            action: () => {
              // “订单作废”和“发车失败”走原有逻辑，其余跳转到客户还车页面
              if (row.closeType === 0 || row.closeType === 1) {
                this.returnCar(row.carId, 2)
              } else {
                this.toReturnCarPage(row)
              }
            },
          },
          {
            label: '放弃退车',
            permission: this.judgePermission('workbench_rent_order_waive') && Number(row.state) === ORDER_STATE.TO_CHECK_FOR_RETURN,
            action: () => this.giveupTheCar(row),
          },
          {
            label: row.settlementState === 4 ? '重新核算' : '订单核算',
            permission: this.judgePermission('workbench_rent_order_settlement') && Number(row.state) === ORDER_STATE.TO_BILL,
            action: () => {
              // “订单作废”和“发车失败”走原有逻辑，其余跳转到客户还车页面
              if (row.closeType === 0 || row.closeType === 1) {
                const { id } = row
                const queryObj = { orderId: id }
                const queryStr = encodeURIComponent(JSON.stringify(queryObj))
                this.$router.push(`/returnLease/returnCar/personalAdd?query=${queryStr}`)
              } else {
                this.toReturnCarPage(row)
              }
            },
          },
          {
            label: '费用结算',
            permission: this.judgePermission('workbench_rent_order_to_receivable') && (Number(row.state) === ORDER_STATE.TO_SETTLEMENT),
            action: () => {
              // “订单作废”和“发车失败”走原有逻辑，其余跳转到客户还车页面
              if (row.closeType === 0 || row.closeType === 1) {
                this.toOrderDetailPage({ id: row.id, type: 8 })
              } else {
                this.toReturnCarPage(row)
              }
            },
          },
          {
            label: '取消',
            permission: [ORDER_STATE.TO_BIND].includes(Number(row.state)),
            action: () => this.handleCancelOrder(row),
          },
          {
            label: '资金划扣',
            permission: true,
            action: () => this.toOrderDetailPage({ id: row.id, type: '6' }, '#sign'),
          },
          {
            label: '一键换车',
            permission: row.state === ORDER_STATE.RENTING &&
              [
                ONE_KEY_CHANGE_STATUS.INITIAL,
                ONE_KEY_CHANGE_STATUS.APPROVAL,
              ].includes(row.changeCarState)
              && this.judgePermission('oneKeyChangeCar'),
            action: () => {
              this.showOneKeyChangeCar(row, 'selectNewCar')
            },
          },
          {
            label: '换车验车',
            permission: row.state === ORDER_STATE.RENTING
              && row.changeCarState === ONE_KEY_CHANGE_STATUS.CHECKING
              && this.judgePermission('oneKeyChangeCar'),
            action: () => {
              this.showOneKeyChangeCar(row, 'checkAndReplaceCar')
            },
          },
        ]
        return actionArr.filter((item) => item.permission)
      },
    },
  ]

  return {
    allTabList,
    stayProcessTabList,
    accountingTabList,
    headData,
  }
}
